import axiosInstance from "app/axiosInstance";
import { GroupsRequestDto } from "../entities/dtos/groups-request.dto";

export const getGroups = async (payload: GroupsRequestDto) => {
  try {
    const { accountId } = payload;
    const response = await axiosInstance.get(`/accounts/${accountId}/groups`);

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
